var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getEligiblePastShiftsByMissionIdFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const shiftsFetchKey = 'eligiblePastShiftsByMissionId';
export const useEligiblePastShiftsByMissionId = ({ missionId, filterData, limit, offset, isVolunteerView, }) => {
    const getEligiblePastShiftsByMissionIdPlatformFn = useTypedPlatformFunction(getEligiblePastShiftsByMissionIdFunctionDef);
    const fetchEligiblePastShiftsByMissionId = (filterData, limit, offset, missionId, isVolunteerView) => {
        return getEligiblePastShiftsByMissionIdPlatformFn({
            missionId,
            isVolunteerView,
            filterData,
            limit,
            offset,
        }); // TODO: Remove Type Casting after PLAT-2704
    };
    const { data, mutate, isLoading, error } = useSWR([shiftsFetchKey, filterData, limit, offset, missionId, isVolunteerView], ([, paramsFilterData, paramsLimit, paramsOffset, paramsMissionId, paramsIsVolunteerView]) => {
        return fetchEligiblePastShiftsByMissionId(paramsFilterData, paramsLimit, paramsOffset, paramsMissionId, paramsIsVolunteerView).catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const fetchShifts = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchShifts,
        shifts: data === null || data === void 0 ? void 0 : data.rows,
        isLoading,
        total: data === null || data === void 0 ? void 0 : data.total,
        analytics: data === null || data === void 0 ? void 0 : data.analytics,
        error,
    };
};
